import { Link } from 'react-router-dom';

const cities = [
  { name: 'Ratingen', tag: 'Hauptstandort', icon: 'ri-map-pin-2-fill', highlight: true, id: 'ratingen' },
  { name: 'Düsseldorf', tag: 'Großraum', icon: 'ri-building-2-line', highlight: false, id: 'duesseldorf' },
  { name: 'Mönchengladbach', tag: 'Rheinland', icon: 'ri-map-pin-line', highlight: false, id: 'moenchengladbach' },
  { name: 'Wuppertal', tag: 'Bergisches Land', icon: 'ri-map-pin-line', highlight: false, id: 'wuppertal' },
  { name: 'Hagen', tag: 'Südwestfalen', icon: 'ri-map-pin-line', highlight: false, id: 'hagen' },
  { name: 'Mettmann', tag: 'Kreis Mettmann', icon: 'ri-map-pin-line', highlight: false, id: 'mettmann' },
  { name: 'Velbert', tag: 'Niederbergisches Land', icon: 'ri-map-pin-line', highlight: false, id: 'velbert' },
  { name: 'Solingen', tag: 'Bergisches Land', icon: 'ri-map-pin-line', highlight: false, id: 'solingen' },
  { name: 'Remscheid', tag: 'Bergisches Land', icon: 'ri-map-pin-line', highlight: false, id: 'remscheid' },
  { name: 'Erkrath', tag: 'Kreis Mettmann', icon: 'ri-map-pin-line', highlight: false, id: 'erkrath' },
  { name: 'Hilden', tag: 'Kreis Mettmann', icon: 'ri-map-pin-line', highlight: false, id: 'hilden' },
  { name: 'Langenfeld', tag: 'Rhein-Wupper', icon: 'ri-map-pin-line', highlight: false, id: 'langenfeld' },
];

const services = [
  { icon: 'ri-brush-line', label: 'Gebäudereinigung' },
  { icon: 'ri-tools-line', label: 'Facility Management' },
  { icon: 'ri-plant-line', label: 'Garten- & Landschaftsbau' },
  { icon: 'ri-hammer-line', label: 'Renovierung & Sanierung' },
];

export default function LeistungsgebieteSection() {
  return (
    <section className="py-16 sm:py-24 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start mb-12 sm:mb-14">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-[2px] bg-[#C8A96E]" />
              <span className="text-[#C8A96E] text-sm font-semibold tracking-widest uppercase">Unser Einsatzgebiet</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Leistungsgebiete in<br />
              <span className="text-[#0D2B4E]">NRW & Rhein-Ruhr</span>
            </h2>
            <p className="text-gray-500 text-sm sm:text-base leading-relaxed max-w-lg">
              Von unserem Standort in <strong className="text-gray-700">Ratingen</strong> aus betreuen wir Privat- und
              Gewerbekunden in der gesamten Region Rhein-Ruhr — von <strong className="text-gray-700">Düsseldorf</strong> über{' '}
              <strong className="text-gray-700">Mönchengladbach</strong> bis nach <strong className="text-gray-700">Hagen</strong>.
              Bei größeren Projekten sind wir auch NRW-weit im Einsatz.
            </p>
          </div>

          {/* Service pills */}
          <div className="flex flex-col justify-center gap-3">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Alle Leistungen vor Ort verfügbar</p>
            <div className="flex flex-wrap gap-2">
              {services.map((s) => (
                <span
                  key={s.label}
                  className="inline-flex items-center gap-2 bg-[#F8F7F4] border border-gray-200 text-gray-700 text-sm font-medium px-4 py-2.5 rounded-full"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className={`${s.icon} text-[#C8A96E] text-sm`} />
                  </div>
                  {s.label}
                </span>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-1">
              <i className="ri-phone-line mr-1" />
              Kostenlose Anfrage: <a href="tel:+4921027398070" className="text-[#0D2B4E] font-semibold hover:underline">02102 7398070</a>
            </p>
          </div>
        </div>

        {/* City grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {cities.map((city) => (
            <Link
              key={city.name}
              to={`/leistungsgebiete#${city.id}`}
              className={`relative flex flex-col items-center text-center rounded-2xl px-3 py-5 border transition-all duration-200 group cursor-pointer ${
                city.highlight
                  ? 'bg-[#0D2B4E] border-[#0D2B4E] text-white hover:bg-[#0a2240]'
                  : 'bg-[#F8F7F4] border-gray-200 text-gray-800 hover:border-[#0D2B4E]/30 hover:bg-[#0D2B4E]/[0.03]'
              }`}
            >
              {city.highlight && (
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#C8A96E] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                  Standort
                </div>
              )}
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center mb-2.5 ${
                city.highlight ? 'bg-white/15' : 'bg-white border border-gray-200 group-hover:border-[#0D2B4E]/20'
              }`}>
                <i className={`${city.icon} text-base ${city.highlight ? 'text-[#C8A96E]' : 'text-[#0D2B4E]'}`} />
              </div>
              <p className={`font-bold text-sm leading-tight mb-1 ${city.highlight ? 'text-white' : 'text-gray-900'}`}>
                {city.name}
              </p>
              <p className={`text-[11px] leading-tight ${city.highlight ? 'text-white/60' : 'text-gray-400'}`}>
                {city.tag}
              </p>
            </Link>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-[#F8F7F4] rounded-2xl px-5 sm:px-7 py-4 border border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#0D2B4E] rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-map-2-line text-white text-base" />
            </div>
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">Ihr Ort nicht dabei?</strong> — Kein Problem. Wir sind NRW-weit tätig und prüfen gerne, ob wir Ihnen helfen können.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Link
              to="/leistungsgebiete"
              className="inline-flex items-center gap-2 bg-white border border-gray-200 text-[#0D2B4E] px-5 py-2.5 rounded-xl font-semibold text-sm hover:border-[#0D2B4E]/40 transition-colors cursor-pointer whitespace-nowrap"
            >
              Alle Gebiete
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-[#0D2B4E] text-white px-5 py-2.5 rounded-xl font-semibold text-sm hover:bg-[#0a2240] transition-colors cursor-pointer whitespace-nowrap"
            >
              Anfrage stellen
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
